import { history } from 'instantsearch.js/es/lib/routers';

// Custom routing that preserves the ?type URL param used by ParagraphTopical
// to control the active tab. Without this, react-instantsearch's default
// historyRouter strips unknown params from the URL via pushState, which
// creates a spurious history entry and breaks the browser back button.
const topicalRouting = {
  router: history({
    createURL({ qsModule, routeState, location }) {
      const type = new URLSearchParams(location.search).get('type');
      const merged = {
        ...routeState,
        ...(type ? { type } : {}),
      };
      const queryString = qsModule.stringify(merged);
      const {
        protocol, hostname, port, pathname, hash,
      } = location;
      const portWithPrefix = port === '' ? '' : `:${port}`;
      if (!queryString) {
        return `${protocol}//${hostname}${portWithPrefix}${pathname}${hash}`;
      }
      return `${protocol}//${hostname}${portWithPrefix}${pathname}?${queryString}${hash}`;
    },
  }),
};

export default topicalRouting;
